"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _drawer = _interopRequireDefault(require("antd/lib/drawer"));

var _CloseOutlined = _interopRequireDefault(require("@ant-design/icons/CloseOutlined"));

var _DollarCircleOutlined = _interopRequireDefault(require("@ant-design/icons/DollarCircleOutlined"));

var _DownOutlined = _interopRequireDefault(require("@ant-design/icons/DownOutlined"));

var _GlobalOutlined = _interopRequireDefault(require("@ant-design/icons/GlobalOutlined"));

var _UpOutlined = _interopRequireDefault(require("@ant-design/icons/UpOutlined"));

var _useMobilePages2 = require("../hooks/useMobilePages");

var _useButtonSettings2 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

var _Partials = require("./Partials");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("../styles/sidebar.less");

var styles = {
  "button": "meepshop-meep-ui__mobileLayout-sidebar__button",
  "buttonText": "meepshop-meep-ui__mobileLayout-sidebar__buttonText",
  "subButton": "meepshop-meep-ui__mobileLayout-sidebar__subButton",
  "pageItem": "meepshop-meep-ui__mobileLayout-sidebar__pageItem",
  "buttonGroupSubmenu": "meepshop-meep-ui__mobileLayout-sidebar__buttonGroupSubmenu",
  "rootButton": "meepshop-meep-ui__mobileLayout-sidebar__rootButton",
  "drawer": "meepshop-meep-ui__mobileLayout-sidebar__drawer",
  "inner": "meepshop-meep-ui__mobileLayout-sidebar__inner",
  "content": "meepshop-meep-ui__mobileLayout-sidebar__content",
  "bottomItem": "meepshop-meep-ui__mobileLayout-sidebar__bottomItem",
  "bottomItemMenuButton": "meepshop-meep-ui__mobileLayout-sidebar__bottomItemMenuButton",
  "buttonBackdrop": "meepshop-meep-ui__mobileLayout-sidebar__buttonBackdrop",
  "open": "meepshop-meep-ui__mobileLayout-sidebar__open",
  "bottomItemMenu": "meepshop-meep-ui__mobileLayout-sidebar__bottomItemMenu",
  "bottomItemMenuTitle": "meepshop-meep-ui__mobileLayout-sidebar__bottomItemMenuTitle",
  "bottomItemMenuClose": "meepshop-meep-ui__mobileLayout-sidebar__bottomItemMenuClose",
  "arrow": "meepshop-meep-ui__mobileLayout-sidebar__arrow"
};

var BottomItem = function BottomItem(_ref) {
  var icon = _ref.icon,
      page = _ref.page,
      background = _ref.background,
      color = _ref.color;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page),
      title = _useButtonSettings.title,
      refTitle = _useButtonSettings.refTitle;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: styles.bottomItem,
    onClick: function onClick() {
      return setOpen(true);
    }
  }, icon, title), /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.buttonBackdrop, " ").concat(open ? styles.open : ''),
    onClick: function onClick() {
      return setOpen(false);
    },
    style: {
      zIndex: 1001
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.bottomItemMenu, " ").concat(open ? styles.open : ''),
    style: {
      background: background,
      color: color,
      fill: color,
      zIndex: 1001
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.bottomItemMenuTitle
  }, refTitle, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: styles.bottomItemMenuClose,
    onClick: function onClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_CloseOutlined["default"], {
    width: 20,
    height: 20
  }))), /*#__PURE__*/_react["default"].createElement("div", null, page.pages.map(function (child) {
    return /*#__PURE__*/_react["default"].createElement(_Partials.Button, {
      styles: styles,
      className: styles.bottomItemMenuButton,
      key: child.id,
      page: child,
      useIcon: false,
      onClick: function onClick() {
        return setOpen(false);
      }
    });
  })))), document.querySelector('body')));
};

var Sidebar = function Sidebar(_ref2) {
  var color = _ref2.color,
      background = _ref2.background,
      open = _ref2.open,
      pagesProps = _ref2.pages,
      useIcon = _ref2.useIcon,
      onClose = _ref2.onClose;

  var _useMobilePages = (0, _useMobilePages2.useMobilePages)(pagesProps),
      currencyPage = _useMobilePages.currencyPage,
      localePage = _useMobilePages.localePage,
      otherPages = _useMobilePages.otherPages,
      bottomPagesCount = _useMobilePages.bottomPagesCount;

  return /*#__PURE__*/_react["default"].createElement(_drawer["default"], {
    className: styles.drawer,
    drawerStyle: {
      background: background,
      color: color,
      fill: color
    },
    width: 330,
    visible: open,
    placement: "left",
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.content
  }, otherPages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(_Partials.PageItem, {
      styles: styles,
      key: page.id,
      page: page,
      useIcon: useIcon,
      groupOpenIcon: /*#__PURE__*/_react["default"].createElement(_UpOutlined["default"], {
        width: 14,
        height: 14
      }),
      groupCloseIcon: /*#__PURE__*/_react["default"].createElement(_DownOutlined["default"], {
        width: 14,
        height: 14
      })
    });
  }))), !!bottomPagesCount && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.bottom
  }, !!localePage && /*#__PURE__*/_react["default"].createElement(BottomItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_DollarCircleOutlined["default"], {
      width: 16,
      height: 16
    }),
    page: localePage,
    background: background,
    color: color
  }), !!currencyPage && /*#__PURE__*/_react["default"].createElement(BottomItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_GlobalOutlined["default"], {
      width: 16,
      height: 16
    }),
    page: currencyPage,
    background: background,
    color: color
  })));
};

var _default = Sidebar;
exports["default"] = _default;